import DocusaurusFooter from '../DocusaurusFooter'
import { Paragraph } from '@eggplant/pattern-library'
import { monitorResults } from '../../docs-routes'

const MonitorResults = () =>
  <Paragraph>
    Monitor Results shows an overview of results from your test runs. You also can view full details of tests and download logs from this area.
    <DocusaurusFooter path={monitorResults} />
  </Paragraph>

export default MonitorResults
